import(/* webpackMode: "eager" */ "/vercel/path0/web/app/(main)/prosjektprat/page.tsx");
